<div class="overlay" *ngIf="showOverlay">
  <div class="center">
    <i class="fas fa-spinner fa-spin me-1"></i>
    <span>{{ message }}</span>
  </div>
</div>
